import { createContext, useContext } from "react";

import { MedicationsHelper } from "./MedicationsHelper.ts";

export const MedicationsContext = createContext<MedicationsHelper>(
  {} as MedicationsHelper
);

export const useMedicationsContext = () => useContext(MedicationsContext);
